module.exports = __webpack_public_path__ + "img/cushion.68a0e75c.png";